<template>
  <i :class="iconClass" :style="[sizeObject, colorObject, translateObject]"></i>
</template>

<script>
  export default {
    props: {
      size: [Number, String],
      color: String,
      transform: {
        type: String,
        default: '',
      },
    },
    computed: {
      iconClass() {
        return [
          'iconfont',
          `icon-${this.$slots.default[0].text}`
        ]
      },
      sizeObject() {
        return {fontSize: this.size + 'px'}
      },
      colorObject() {
        return {color: this.color}
      },
      translateObject() {
        return {
          transform: this.transform
        }
      }
    }
  }
</script>
